import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import HomeworkComment from "../../../containers/admin/reports/homework-comment";
import { getAllGroupsRequest } from "../../../modules/admin-modules/groups/Actions";
import { getAllHomeworksAdminRequest } from "../../../modules/admin-modules/homework/Actions";
import { homeworkAttendenceReportRequest } from "../../../modules/superadmin-modules/reports/Actions";
const HomeworkAttendanceReport = () => {
  const baseUrl = "https://enoughphysics.com/enoughapi";

  const dispatch = useDispatch();
  const [homeworkId, setHomeworkId] = useState("");
  const [groupId, setGroupId] = useState("all");

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (homeworkId) {
      if (groupId == "all")
        dispatch(homeworkAttendenceReportRequest(`homework_id=${homeworkId}`));
      else
        dispatch(
          homeworkAttendenceReportRequest(
            `homework_id=${homeworkId}&group_id=${groupId}`
          )
        );
    }
  }, [homeworkId, groupId]);

  useEffect(() => {
    dispatch(getAllHomeworksAdminRequest());
  }, []);
  useEffect(() => {
    dispatch(getAllGroupsRequest());
  }, []);
  const homeworks = useSelector((state) => state.homework.adminHomeworks);
  const homeworkAttendance = useSelector(
    (state) => state.reports.homeworkAttendance
  );
  const isLoading = useSelector((state) => state.reports.isLoading);
  const groups = useSelector((state) => state.groups.groups);

  const options = groups?.map((group) => {
    return { label: group?.name, value: group?.id };
  });

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const homeworksOptions = homeworks?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const viewData = (data) => {
    setData(data);
  };
  const headers = [{ label: "name", key: "name" }];
  const Data = homeworkAttendance?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      name: data?.name,
      homework: (
        <Button as="a" href={`${data?.homework?.file}`} target="_blank">
          الحل
        </Button>
      ),
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: " الحل",
      accessor: "homework",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10"
          flexWrap="wrap"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير حضور الواجبات
          </Text>
          <Flex
            w={{ base: "100%", md: "70%" }}
            justifyContent="space-between"
            alignItems="center"
            gap={2}
          >
            <Box w="50%">
              <Select
                options={homeworksOptions}
                isMulti={false}
                onChange={(data) => {
                  setHomeworkId(data?.value);
                  setGroupId("all");
                }}
                styles={colourStyles}
                placeholder="Select Homework"
              />
            </Box>
            <Box width="50%">
              <Select
                options={[{ label: "All", value: "all" }, ...options]}
                onChange={(data) => {
                  setGroupId(data?.value);
                }}
                styles={colourStyles}
                placeholder="المجموعات"
              />
            </Box>
            <Box
              mx="10px"
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
            >
              <CSVLink
                headers={headers}
                data={Data?.length != 0 ? Data : []}
                filename={"homework-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
      <HomeworkComment data={data} homeworkId={homeworkId} />
    </Layout>
  );
};

export default HomeworkAttendanceReport;
